export default __webpack_public_path__ + "static/media/crwn-full.d41a8aa7.jpg";